import { render, staticRenderFns } from "./UserEditor.html?vue&type=template&id=3e47f6ec&scoped=true&"
import script from "./UserEditor.js?vue&type=script&lang=js&"
export * from "./UserEditor.js?vue&type=script&lang=js&"
import style0 from "./UserEditor.scss?vue&type=style&index=0&id=3e47f6ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e47f6ec",
  null
  
)

export default component.exports